const state = {
  loading:false,
  out:false,
  mes:false,
  n:''

}
const getter = {}

const mutations = {

	set(state,n){
		state.n = n
	},
  setMes(state,num){
    if(num == 1){
      state.mes = true
    }else{
      state.mes = false
    }    
  }
   
}
const actions = {

	closeLoading(context,n){
   	context.commit('set', n)
	},
  closeMes(context,num){
    context.commit('setMes',num)
  } 
}
export default {
  state,
  getter,
  mutations,
  actions
}







// WEBPACK FOOTER //
// ./src/store/modules/loading.js